export enum TrackingFlowTypeEnum {
  POWER = "power",
  STANDRARD = "standard",
  PARTNER = "partner",
  TrackAndTrace = "trackAndTrace",
  Vertical = "vertical",
  VerticalV2 = "verticalV2",
  ProductSlider = "productSlider",
  ProductCard = "productCard",
  SalaryConfig = "salaryinsurance_config_card"
}
